module.exports = __webpack_public_path__ + "static/media/life-slow.526162a8.mp3";